import React, { useEffect, useState } from "react";

const SearchSelect = (props) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [PlaceholderIsShown, setPlaceholderIsShown] = useState(true);
  const [SelectedOptions, setSelectedOptions] = useState([]);
  const [Changed, setChanged] = useState(false);
  var SearchTimeout;

  useEffect(() => {
    setSelectedOptions(props.SelectedItems);
  }, [props.SelectedItems]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleSearch = () => {
    let Keyword = document.getElementById(props.Id).value;
    props.ToggleSearch(Keyword);
  };
  const handleValueChange = (e) => {
    clearTimeout(SearchTimeout);
    if (e.target.value.length > 0) {
      setPlaceholderIsShown(false);
      SearchTimeout = setTimeout(handleSearch, 1500);
    } else {
      setPlaceholderIsShown(true);
      props.RemoveSelectedState();
      props.UpdateList(SelectedOptions);
      setTimeout(() => {
        props.ToggleSearch("");
      }, 200);
    }
  };

  const selectOption = (Item) => {
    if (!Changed) {
      setChanged(true);
    }
    let Id = Item.id;
    if (
      document.getElementById(Id + "-option").classList.contains("selected")
    ) {
      document.getElementById(Id + "-option").classList.remove("selected");
    } else if (SelectedOptions.length < 5) {
      document.getElementById(Id + "-option").classList.add("selected");
    }
    updateSelectedItems();
  };

  const updateSelectedItems = () => {
    let SelectedItems = [];
    [...props.Options].concat(props.SelectedItems).map((Item) => {
      if (
        document.getElementById(Item.id + "-option") !== null &&
        document
          .getElementById(Item.id + "-option")
          .classList.contains("selected")
      ) {
        SelectedItems.push(Item);
      }
      setSelectedOptions([...new Set(SelectedItems)]);
    });
  };

  const close = () => {
    props.RemoveSelectedState();
    document.getElementById(props.Id).value = "";
    setPlaceholderIsShown(true);
    if (Changed) {
      props.UpdateList(SelectedOptions);
    }
    setTimeout(() => {
      setIsOpen(false);
    }, 150);
  };

  const handleClear = () => {
    setSelectedOptions([]);
    props.ClearInput();
    props.UpdateList([]);
  };

  return (
    <div className="search-select-wrapper">
      {IsOpen ? <div className="outline" onClick={() => close()}></div> : null}
      <div className="trigger" onClick={() => setIsOpen(!IsOpen)}>
        {props.SelectedItems.length === 0 ? (
          <p className="select-label">{props.Label}</p>
        ) : (
          <React.Fragment>
            <p className="select-label select-label-transformed">
              {props.Label}
            </p>
            <span className="selected-trigger">
              <p className="selected-count">
                {props.SelectedItems.length + " " + translateText("selected")}
              </p>
            </span>
          </React.Fragment>
        )}
        <i className="feather-chevron-down"></i>
      </div>
      {props.SelectedItems.length > 0 ? (
        <i
          onClick={() => handleClear()}
          id="search-select-clear"
          className="feather-x-circle"
        ></i>
      ) : null}

      <div className={IsOpen ? "search-dropdown is-shown" : "search-dropdown"}>
        <i className="feather-search"></i>
        {PlaceholderIsShown ? (
          <p className="search-placeholder">{props.SearchLabel}</p>
        ) : null}
        <input
          onChange={(e) => handleValueChange(e)}
          className="search-input"
          id={props.Id}
          autoComplete="off"
        />
        {IsOpen ? (
          <React.Fragment>
            {props.Options.length === 0 ? (
              <section className="options-wrapper">
                <p className="no-res-text">
                  {translateText("no_results_found")}
                </p>
              </section>
            ) : (
              <section className="options-wrapper">
                <React.Fragment>
                  {props.SelectedItems.map((Item) => (
                    <React.Fragment>
                      {Item.title.length > 0 ? (
                        <span
                          className="option-item selected"
                          id={Item.id + "-option"}
                          onClick={() => selectOption(Item)}
                        >
                          <i className="feather-check"></i>
                          <p>{Item.title}</p>
                        </span>
                      ) : null}
                    </React.Fragment>
                  ))}
                </React.Fragment>
                <React.Fragment>
                  {props.Options.map((Item) => (
                    <React.Fragment>
                      {Item.title.length > 0 ? (
                        <span
                          className="option-item"
                          id={Item.id + "-option"}
                          onClick={() => selectOption(Item)}
                        >
                          <i className="feather-check"></i>
                          <p>{Item.title}</p>
                        </span>
                      ) : null}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              </section>
            )}
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};
export default SearchSelect;
